/* eslint-disable jira/filename-case */
import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import messages from '../messages';

export function AttachmentsGraphic() {
	const { formatMessage } = useIntl();
	return (
		<svg
			width="395"
			height="276"
			viewBox="0 0 395 276"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect width="395" height="276" fill="#B3B9C4" />
			<path
				d="M-6020 -813C-6020 -814.105 -6019.1 -815 -6018 -815H1107C1108.1 -815 1109 -814.105 1109 -813V1383C1109 1384.1 1108.1 1385 1107 1385H-6018C-6019.1 1385 -6020 1384.1 -6020 1383V-813Z"
				fill="#F1F2F4"
			/>
			<path
				d="M-6018 -814H1107V-816H-6018V-814ZM1108 -813V1383H1110V-813H1108ZM1107 1384H-6018V1386H1107V1384ZM-6019 1383V-813H-6021V1383H-6019ZM-6018 1384C-6018.55 1384 -6019 1383.55 -6019 1383H-6021C-6021 1384.66 -6019.66 1386 -6018 1386V1384ZM1108 1383C1108 1383.55 1107.55 1384 1107 1384V1386C1108.66 1386 1110 1384.66 1110 1383H1108ZM1107 -814C1107.55 -814 1108 -813.552 1108 -813H1110C1110 -814.657 1108.66 -816 1107 -816V-814ZM-6018 -816C-6019.66 -816 -6021 -814.657 -6021 -813H-6019C-6019 -813.552 -6018.55 -814 -6018 -814V-816Z"
				fill="black"
				fill-opacity="0.1"
			/>
			<g filter="url(#filter0_d_134_51661)">
				<rect width="484" height="536" transform="translate(-59 -96)" fill="#F1F2F4" />
				<rect
					width="200"
					height="244"
					transform="matrix(0.997242 -0.0742187 0.0655601 0.997849 0 15.8682)"
					fill="#1868DB"
				/>
				<rect
					x="172.24"
					y="13.9958"
					width="193"
					height="243"
					transform="rotate(1.512 172.24 13.9958)"
					fill="#FCA700"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M200.349 14.738L215.445 244.499L166.059 248.175L172.24 13.9961L200.349 14.738Z"
					fill="#09326C"
				/>
				<rect width="284" height="185" transform="translate(41 40)" fill="white" />
				<rect width="284" height="56" transform="translate(41 40)" fill="white" />
				<g clip-path="url(#clip0_134_51661)">
					<g clip-path="url(#clip1_134_51661)">
						<g clip-path="url(#clip2_134_51661)">
							<g clip-path="url(#clip3_134_51661)">
								<path
									d="M67.2752 72.3371H65.6108C63.1006 72.3371 61.2998 70.7996 61.2998 68.5482H70.2492C70.7131 68.5482 71.0132 68.8777 71.0132 69.3444V78.35C68.7758 78.35 67.2752 76.5379 67.2752 74.012V72.3371ZM71.6953 67.8618H70.0309C67.5207 67.8618 65.7199 66.3517 65.7199 64.1003H74.6694C75.1332 64.1003 75.4606 64.4023 75.4606 64.8691V73.8747C73.2233 73.8747 71.6953 72.0626 71.6953 69.5366V67.8618ZM76.1427 63.4139H74.4784C71.9682 63.4139 70.1674 61.8764 70.1674 59.625H79.1168C79.5806 59.625 79.8808 59.9545 79.8808 60.3938V69.3993C77.6434 69.3993 76.1427 67.5872 76.1427 65.0613V63.4139Z"
									fill="#1868DB"
								/>
							</g>
						</g>
					</g>
					<text
						fill="#172B4D"
						xmlSpace="preserve"
						// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
						style={{ whiteSpace: 'pre' }}
						font-size="16"
						fontWeight="590"
						letterSpacing="0px"
					>
						<tspan x="91" y="73.6875">
							{formatMessage(messages.attachmentsSvgText1)}
						</tspan>
					</text>
				</g>
				<rect
					x="62"
					y="96"
					width="242"
					height="86"
					fill="#F8F8F8"
					stroke="#DDDEE1"
					stroke-width="2"
				/>
				<rect
					x="305.285"
					y="131.444"
					width="67.5"
					height="67.5"
					transform="rotate(9.40907 305.285 131.444)"
					fill="#BF63F3"
				/>
				<rect
					x="311.837"
					y="143.896"
					width="51.5625"
					height="48.4375"
					transform="rotate(9.40907 311.837 143.896)"
					fill="white"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M364.461 147.322L310.509 138.381L301.568 192.333L355.52 201.274L364.461 147.322ZM332.684 159.874C331.979 164.131 327.956 167.01 323.7 166.304C319.443 165.599 316.564 161.576 317.269 157.32C317.975 153.063 321.997 150.184 326.254 150.889C330.511 151.595 333.389 155.617 332.684 159.874ZM343.607 165.644L312.161 188.149L350.697 194.535L353.252 179.12L343.607 165.644Z"
					fill="#BF63F3"
				/>
				<path
					d="M288.264 112.961C288.597 116.147 288.316 119.659 289.538 122.594C291.972 118.595 297 113.622 300.141 111.264C302.478 110.106 303.709 108.481 306.195 107.934C306.195 107.934 305.818 107.83 305.806 107.829C313.408 103.44 324.594 99.817 333.578 100.05C333.552 100.07 333.516 100.084 333.553 100.112C332.711 100.263 328.729 100.994 328.723 100.993C331.916 101.688 335.151 100.45 338.368 100.689C337.8 99.9931 335.473 100.377 335.227 100.095C341.763 99.6704 348.768 100.828 354.757 103.56C354.411 103.595 353.176 102.789 352.742 103.318C353.598 103.544 357.241 105.296 355.477 104.01C365.128 106.9 375.181 114.37 381.665 122.403C383.204 124.372 383.438 125.099 381.455 123.646L381.45 123.98C379.311 121.545 376.408 120.164 375.314 117.573C372.666 117.971 368.557 111.403 365.421 110.821C365.95 112.387 358.128 105.649 358.927 107.588C345.481 102.752 328.613 100.106 315.535 107.065L315.584 106.942C305.634 109.293 297.483 115.729 290.995 123.678C292.689 123.441 295.357 122.435 296.32 123.085C306.381 121.169 291.511 127.127 287.883 126.087L287.915 126.067C287.915 126.067 287.084 125.968 287.119 126.072C285.924 124.044 285.334 112.204 288.266 112.949L288.264 112.961Z"
					fill="#101214"
				/>
			</g>
			<defs>
				<filter
					id="filter0_d_134_51661"
					x="-63"
					y="-96"
					width="492"
					height="544"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="4" />
					<feGaussianBlur stdDeviation="2" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_134_51661" />
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_134_51661"
						result="shape"
					/>
				</filter>
				<clipPath id="clip0_134_51661">
					<rect width="236" height="24" fill="white" transform="translate(59 56)" />
				</clipPath>
				<clipPath id="clip1_134_51661">
					<rect width="24" height="24" fill="white" transform="translate(59 56)" />
				</clipPath>
				<clipPath id="clip2_134_51661">
					<rect width="24" height="24" fill="white" transform="translate(59 56)" />
				</clipPath>
				<clipPath id="clip3_134_51661">
					<rect width="18.581" height="18.725" fill="white" transform="translate(61.2998 59.625)" />
				</clipPath>
			</defs>
		</svg>
	);
}
